"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _BaseSeoManager2 = _interopRequireDefault(require("../BaseSeoManager"));

var _SeoManagerHelpers = require("../helpers/SeoManagerHelpers");

var _CasaOldHelmetDataHelper = require("../helpers/CasaOldHelmetDataHelper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var MANAGER_TYPE = _SeoManagerHelpers.HELPER_MANAGER_TYPE.RE;

var RealEstateSeoManager = /*#__PURE__*/function (_BaseSeoManager) {
  _inherits(RealEstateSeoManager, _BaseSeoManager);

  var _super = _createSuper(RealEstateSeoManager);

  function RealEstateSeoManager(domain, lang) {
    var _this;

    _classCallCheck(this, RealEstateSeoManager);

    _this = _super.call(this, domain, lang);
    _this.locations = [];
    _this.num_levels = 0;
    _this.max_levels = 0;
    return _this;
  }

  _createClass(RealEstateSeoManager, [{
    key: "decodeLevel",
    value: function decodeLevel(level, value) {
      if (!this.isValidDecode()) {
        return;
      }

      this.valid_levels["level".concat(level)] = true;

      switch (level) {
        case 1:
          this.addDecodeData('level1', 'real-estate');
          break;

        case 2:
          this.decodeLevel2(value);
          break;

        case 3:
          this.decodeLevel3(value);
          break;

        default:
          this.valid_levels.level4 = false;
          break;
      }

      if (level > this.max_levels && this.max_levels > 0) {
        this.valid_levels["level".concat(level)] = false;
      }
    }
  }, {
    key: "decodeLevel2",
    value: function decodeLevel2(value) {
      this.max_levels = 2;
      this.decodeGeo(value);
    }
  }, {
    key: "decodeLevel3",
    value: function decodeLevel3(value) {
      this.decodeAree(value);
    }
  }, {
    key: "decode",
    value: function decode(url) {
      return _get(_getPrototypeOf(RealEstateSeoManager.prototype), "decode", this).call(this, url, MANAGER_TYPE);
    }
  }, {
    key: "decodeGeo",
    value: function decodeGeo(value) {
      var geoType = (0, _SeoManagerHelpers.decodeGeoType)(value, 2);
      var geo = Object.assign({}, geoType.geo);
      var dgeo = Object.assign({}, geoType.dgeo);

      if (geo.type === 'city') {
        this.max_levels++;
      }

      this.addDecodeData("level2", geo.type);
      this.addData('geo', dgeo);

      if (geoType.valid_levels) {
        this.valid_levels = geoType.valid_levels;
      }

      return geo;
    }
  }, {
    key: "decodeAree",
    value: function decodeAree(value) {
      var dgeo = this.data.geo;
      var geo = (0, _SeoManagerHelpers.decodeAree)(value);
      dgeo.l10 = _defineProperty({}, geo.type, geo.level1);
      this.addDecodeData('level3', geo.type);
      this.addData('geo', dgeo);
      return geo;
    }
  }, {
    key: "createSeoData",
    value: function createSeoData(_ref) {
      var locations = _ref.locations;
      this.seo_data.seo = (0, _CasaOldHelmetDataHelper.createHelmet)({
        domain: this.domain,
        lang: this.lang,
        seodata: this.data,
        locations: locations
      });
    }
    /*
    createSeoData({ locations }) {
      this.seo_data.seo = {};
      this.num_levels = Object.keys(this.data.seo_decode_type).length;
      this.locations = locations;
       const brand = this.domain;
      const city = this.getGeoLocationLevel(9);
      const department = this.getGeoLocationLevel(5);
      const department_nb = this.getDepartmentNb();
      
      const params = {
        seo_decode_type: this.data.seo_decode_type,
        SEO_SRP_SPECS,
        domain: this.domain,
        lang: this.lang,
      };
      this.seo_data.seo = getSeoDataFromJson(params);
      Object.keys(this.seo_data.seo).map((el) => {
        // TODO - eval doesn't work on internet explorer
        // this.seo_data.seo[el] = eval('`' + this.seo_data.seo[el] + '`');
        if (typeof this.seo_data.seo[el] === 'string') {
          try {          
            this.seo_data.seo[el] = this.seo_data.seo[el]
              .replace('${brand}', brand)
              .replace('${city}', city)
              .replace('${department}', department)
              .replace('${department_nb}', department_nb);
          } catch (e) { }
        } else {
          this.seo_data.seo[el] = this.domain;
        }
      });
    }
    */

  }, {
    key: "getGeoLocationLevel",
    value: function getGeoLocationLevel(level) {
      try {
        if (this.locations && this.locations[0] && this.locations[0].levels && this.locations[0].levels["L".concat(level)]) {
          return this.locations[0].levels["L".concat(level)];
        }

        return '';
      } catch (e) {
        return '';
      }
    }
  }, {
    key: "getDepartmentNb",
    value: function getDepartmentNb() {
      try {
        if (this.data && this.data.geo && this.data.geo.departement_nb) {
          return this.data.geo.departement_nb;
        }

        return '';
      } catch (e) {
        return '';
      }
    }
  }], [{
    key: "getLevel1Slug",
    value: function getLevel1Slug() {
      return {
        type: MANAGER_TYPE,
        regexp: ['immobilier', 'real-estate', 'immobilien', 'realestate']
      };
    }
  }]);

  return RealEstateSeoManager;
}(_BaseSeoManager2["default"]);

var _default = RealEstateSeoManager;
exports["default"] = _default;